export const isFullStatic = false
export const staticPath = "/home/app/car/src/car-client/.nuxt/car/static-json"
export const publicPath = "https://static-cz.car.gr/_nuxt/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"